// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
define([
        'text!edge/platform/widgets/accordion/directives/templates/accordion.html'
    ],
    (templateStr)=> {
        return [()=> {
            return {
                restrict: 'EA',
                controller: 'GwPlAccordionController',
                transclude: true,
                replace: false,
                template: templateStr,
                scope: {
                    'flavour': '@'
                }
            };
        }];
    });


// WEBPACK FOOTER //
// ../common/js/src/edge/platform/widgets/accordion/directives/accordion.js